import React, { useState, useEffect } from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import * as techApi from '../../../lib/api/tech';
import * as fileApi from '../../../lib/api/file';
import { setTech, viewTech } from '../../../modules/projectModule/tech';
import { listTechFiles } from '../../../modules/projectModule/techFiles';
import { listProjectTechs } from '../../../modules/projectModule/projectTechs';
import TechPlanForm from '../../../components/projectmng/support/TechPlanForm';
import _ from 'lodash';
import { setTechPlan } from '../../../modules/projectModule/techPlan';

const TechPlanFormContainer = ({ project, tech, techPlan, user, reloadTech }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();


  const [initialValues, setInitialValues] = useState({
    plnTitle: '',
    plnTyp: '',
    plnStrtDt: '',
    plnEndDt: '',
    plnContext: '',
    files: [{ file: null, fileDesc: '' }]
  });

  useEffect(() => {

    if (techPlan && tech.planUuid !== null) {
      const cloneTechPlan = _.cloneDeep(techPlan);
      cloneTechPlan.files = [{ file: null, fileDesc: '' }];
      setInitialValues(cloneTechPlan);
    }
  }, [techPlan, tech?.planUuid])





  const validationSchema = yup.object({
    plnTitle: yup.string('').required('작업 계획 제목을 입력하세요'),
    plnTyp: yup.string().required('작업 계획 종류를 선택하세요'),
    plnStrtDt: yup
      .date()
      .required('작업 계획 시작일을 입력하세요')
      .nullable()
      .default(undefined),
    plnEndDt: yup
      .date()
      .required('작업 계획 종료일을 입력하세요')
      .min(yup.ref('plnStrtDt'), '작업 계획 종료일을 확인하세요')
      .when('plnStrtDt', (plnStrtDt, schema) => {
        if (plnStrtDt) return schema.required('작업 계획 종료일을 입력하세요');
      })
      .nullable()
      .default(undefined),
    plnContext: yup.string('').required('작업 계획 사항을 입력하세요'),
  });


  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      onSave(values);
      setSubmitting(false);
    },
  });

  const onSave = async (values) => {
    let dataToSubmit = {
      reqUuid: tech.reqUuid,
      prjUuid: tech.prjUuid,
      plnTitle: values.plnTitle,
      plnTyp: values.plnTyp,
      plnStrtDt: (values.plnStrtDt) ? dayjs(values.plnStrtDt).format('YYYY-MM-DD') : null,
      plnEndDt: (values.plnEndDt) ? dayjs(values.plnEndDt).format('YYYY-MM-DD') : null,
      plnContext: values.plnContext,
      reqStatus: '작업계획',
      reqGrade: 3,
      plnUsr: user.usrUuid,
    };

    try {
      let res = null;
      if (tech.planUuid === null || tech.planUuid === '') {
        res = await techApi.addTechPlan(dataToSubmit);
      } else {
        dataToSubmit.planUuid = techPlan.planUuid;
        res = await techApi.editTechPlan(dataToSubmit);
      }


      if (res.data.info) {
        if (values.files.length > 0 && values.files[0].file != null) {
          values.files.forEach(value => {
            onFileSave(value, tech);
          })
        };
        reloadTech(tech.reqUuid);
        dispatch(setTechPlan(res.data.info))
        dispatch(listTechFiles('tech', tech.reqUuid));
      }
      enqueueSnackbar('저장 성공', {
        variant: 'success',
      });
    } catch (err) {

      let message =
        err.response !== 'undefined' ? err.response?.data?.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const onFileSave = async (value, tech) => {
    let formData = new FormData();
    formData.append('fileDt', value.file);
    formData.append('fileTyp', 'tech');
    formData.append('fileAttrVal1', tech.reqUuid);
    formData.append('fileAttrVal2', tech.prjUuid);
    formData.append('fileAttrVal3', '기술 지원 예정');
    formData.append('fileDesc', value.fileDesc);

    try {
      const response = await fileApi.addFiles(formData);

      if (response.data.result === 'success') {
        enqueueSnackbar("첨부파일 업로드 성공", {
          variant: 'success',
        });
      }

    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  return (
    <>
      <TechPlanForm formik={formik} techPlan={techPlan} />
    </>
  );
};

export default TechPlanFormContainer;
